// extracted by mini-css-extract-plugin
module.exports = {"container":"usercenter_container__2Fm8J","userInfo":"usercenter_userInfo__1uqxp","dataListBox":"usercenter_dataListBox__gX1lg"};